import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Fetches PTT NZ's live plan catalogue from the Connectivity Portal (proxied
 * through our own backend). Groups plans by category and exposes any
 * portal-supplied T&Cs per category. Falls back to `{ error: true }` if the
 * Portal is unreachable and no cached snapshot exists either. */
export const usePlans = () => {
  const [state, setState] = useState({ loading: true, error: false, plansByCategory: {}, categoryTerms: {}, source: null });

  useEffect(() => {
    let active = true;
    axios
      .get(`${BACKEND_URL}/api/plans`)
      .then(({ data }) => {
        if (!active) return;
        const plansByCategory = {};
        (data.plans || []).forEach((p) => {
          if (!plansByCategory[p.category]) plansByCategory[p.category] = [];
          plansByCategory[p.category].push(p);
        });
        Object.values(plansByCategory).forEach((list) => list.sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)));
        setState({ loading: false, error: false, plansByCategory, categoryTerms: data.category_terms || {}, source: data.source });
      })
      .catch(() => {
        if (!active) return;
        setState({ loading: false, error: true, plansByCategory: {}, categoryTerms: {}, source: null });
      });
    return () => { active = false; };
  }, []);

  return state;
};
